import discountsStrings from '../../strings';
import {
  CreateOfferPlusIcon,
  OffersEmptyStateActions,
  OffersEmptyStateButton,
  OffersEmptyStateOutlineButton,
  OffersEmptyStateSubtitle,
  OffersEmptyStateTitle,
  OffersEmptyStateWrapper,
} from '../../views/Discounts.style';

interface DiscountOffersEmptyStateProps {
  onCreateOffer: () => void;
  onCreateBundle?: () => void;
}

const DiscountOffersEmptyState = ({
  onCreateOffer,
  onCreateBundle,
}: DiscountOffersEmptyStateProps) => (
  <OffersEmptyStateWrapper>
    <OffersEmptyStateTitle>{discountsStrings.noOffersTitle}</OffersEmptyStateTitle>
    <OffersEmptyStateSubtitle>{discountsStrings.noOffersSubtitle}</OffersEmptyStateSubtitle>
    <OffersEmptyStateActions>
      {onCreateBundle ? (
        <OffersEmptyStateOutlineButton type="button" onClick={onCreateBundle}>
          <CreateOfferPlusIcon>+</CreateOfferPlusIcon>
          {discountsStrings.createBundleBtn}
        </OffersEmptyStateOutlineButton>
      ) : null}
      <OffersEmptyStateButton type="button" onClick={onCreateOffer}>
        <CreateOfferPlusIcon>+</CreateOfferPlusIcon>
        {discountsStrings.createOfferBtn}
      </OffersEmptyStateButton>
    </OffersEmptyStateActions>
  </OffersEmptyStateWrapper>
);

export default DiscountOffersEmptyState;
